import * as types from '../actions/actionTypes';
import { ImeasurementPointResult, IopenRepairConflict } from '../models';
import { IinitialState } from '../types/rootState';

export type OpenRepairConflictsState = {
    conflicts: IopenRepairConflict[];
    blockedResults: ImeasurementPointResult[];
    savedCount: number;
};

const initialOpenRepairConflictsState: OpenRepairConflictsState = {
    conflicts: [],
    blockedResults: [],
    savedCount: 0
};

export const getOpenRepairConflicts = (state: IinitialState): OpenRepairConflictsState => state.openRepairConflicts;

export const hasOpenRepairConflicts = (state: IinitialState): boolean =>
    state.openRepairConflicts.conflicts.length > 0;

/**
 * Blocked inspection saves returned by the API as HTTP 409 (open repair on the asset).
 * blockedResults keeps the rejected answers so the user can retry with the override.
 */
const openRepairConflictsReducer = (
    state: OpenRepairConflictsState = initialOpenRepairConflictsState,
    action: any
): OpenRepairConflictsState => {
    switch (action.type) {
        case types.SET_OPEN_REPAIR_CONFLICTS:
            return {
                conflicts: action.conflicts,
                blockedResults: action.blockedResults,
                savedCount: action.savedCount
            };
        case types.CLEAR_OPEN_REPAIR_CONFLICTS:
        case types.USER_LOGOUT_SUCCESS:
            return initialOpenRepairConflictsState;
        default:
            return state;
    }
};

export default openRepairConflictsReducer;
